import type { UserRoleType } from '~/types';

export const hasRole = (role: UserRoleType, allowedRoles: readonly UserRoleType[]): boolean => {
  return allowedRoles.includes(role);
};
